import $ from "jquery";
import CONFIG from "@bd-core/config";
import videojs from "video.js";
import bdjs from "@bd-core/bdjs";
import GameLogic from "@bd-core/game-logic";

export default class OutroVideo {
    constructor() {
        this.$outroFinish = $(".videobox.outro-finish");
        this.$outroTimeout = $(".videobox.outro-timeout");

        /** @type {import("video.js").VideoJsPlayer | null} */
        this.videoFinish = null;

        /** @type {import("video.js").VideoJsPlayer | null} */
        this.videoTimeout = null;
    }

    init() {
        let self = this;

        if ($("#outro-video-finish").length) {
            this.videoFinish = videojs("outro-video-finish", {
                controls: true,
                autoplay: false,
                preload: "auto",
            });

            this.videoFinish.on("ended", () => {
                this.afterPlay();
            });

            this.videoFinish.on("error", function () {
                self.videoFinish = null;
            });
        }

        if ($("#outro-video-timeout").length) {
            this.videoTimeout = videojs("outro-video-timeout", {
                controls: true,
                autoplay: false,
                preload: "auto",
            });

            this.videoTimeout.on("ended", () => {
                // this.afterPlay();
                GameLogic.maybeShowTimeoutPopup(true);
            });

            this.videoTimeout.on("error", function () {
                self.videoTimeout = null;
            });
        }
    }

    showVideo(isTimeout) {
        if (isTimeout) {
            this.$outroTimeout.addClass("is-open outro-video");
        } else {
            this.$outroFinish.addClass("is-open outro-video");
        }
    }

    afterPlay() {
        bdjs.showLoading();
        const currentLang = CONFIG.wpml_config.current_language;
        setTimeout(() => {
            //go to result page on video ended
            document.location.href = CONFIG.siteURL + "/result/?lang=" + currentLang;
        }, GameLogic.transisitonDuration);
    }
}
